import React from 'react';
import {Stack, Typography} from '@mui/material';
import TarotmailCustomerComp from '../../components/TarotmailCustomerComp.js';
import withMainContainer from '../../components/WithMainContainer.js';
import {withTitle} from '../../title.js';
import {SIMONA_USER_ID} from '../../util/util.js';

const TarotmailCustomerSimona = ()=>{
    return <TarotmailCustomerComp id={SIMONA_USER_ID} hideName description={<Stack direction="column" gap={2}>
      <Typography>
        לפעמים כל מה שצריך כדי לשנות את כל היום - זה מסר אחד נכון בזמן הנכון.
      </Typography>
      <Typography>
        משפט שיזכיר לך מה באמת חשוב, או נקודת מבט שתפתח לך את הלב והמחשבה. החלטתי לתת לך בדיוק את זה - מתנה קטנה, אבל כזאת שיכולה לעשות שינוי גדול.
      </Typography>
      <Typography>
        קבלו ממני מסר אישי - כל יום, במשך שבוע
      </Typography>
      <Typography>
        בכל בוקר, למשך שבעה ימים, יחכה לך במייל <strong>מסר יומי מלא ומעמיק מהקלפים</strong> - שיפתח את המחשבה, יעודד, ויכוון אותך לדרך הנכונה.
      </Typography>
      <Typography>
        המסרים כוללים הכוונה כללית לאותו יום, וגם התמקדות מיוחדת לתחום הקריירה ולתחום האהבה. כל מסר נבחר בקפידה, כדי לתת לך זווית ראייה חדשה, להוסיף בהירות וביטחון, ולעזור לך לפתוח את היום באנרגיה טובה.<br/>
        ההרשמה חינם - פשוט ממלאים שם ומייל, ואני אשלח לך מתנה קטנה של השראה, מדי בוקר, במשך שבוע שלם.
      </Typography>
    </Stack>}/>;
};

export default withMainContainer(withTitle('מסר שבועי במייל', TarotmailCustomerSimona), {footerMargin: 4});